import WrapperService from "@/modules/core/services/wrapper-service";

const ENDPOINT = "https://nominatim.openstreetmap.org/search?format=json"

const serviceName = "GPS-Utils: ";

export default class GPSUtils {
  /**
   * Converts degree to radian
   *
   * @param degrees degree to convert to radian
   * @returns {Number}
   */
  static degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
  }

  /**
   * Calculates the distance [m] from one coordinate to another coordinate
   *
   * @param lat1 Latitude of first coordinate
   * @param lng1 Longitude of first coordinate
   * @param lat2 Latitude of second coordinate
   * @param lng2 Longitude of second coordinate
   * @returns {Number}
   */
  static calcDistance(lat1, lng1, lat2, lng2) {
    if(!lat1 || !lng1 || !lat2 || !lng2){
      return -1;
    }
    var eartRadiusKm = 6371;

    var dLat = this.degreesToRadians(lat2 - lat1);
    var dLng = this.degreesToRadians(lng2 - lng1);

    lat1 = this.degreesToRadians(lat1);
    lat2 = this.degreesToRadians(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return (eartRadiusKm * c) * 1000;
  }

  /**
   * Checks if the zip with the given country is valid
   *
   * @param country country to check zip for e.g. 'austria'
   * @param zip zip to check if it is valid
   * @returns {boolean} true if zip is valid, false if zip is invalid
   */
  static isValidZIP(country, zip) {
    if (country === 'austria' && zip.length === 4) return true;
    else if (country === 'germany' && zip.length === 5) return true;
    else return false;
  }

  /**
   * Returns countryName by countryId
   *
   * @param countryId id of country
   * @param countryList all countries
   * @returns {string} name of found country
   */
  static getCountryNameById(countryId, countryList) {
    let countryName = "";
    for (let i = 0; i < countryList.length; i++) {
      if (countryList[i].id === countryId) {
        countryName = countryList[i].name;
      }
    }

    return countryName;
  }

  /**
   * Reads the city and province by the zip
   *
   * @param zip zip to get city and province for
   * @param countryName name of the country
   * @param currentLanguage current set language
   * @param allProvinces list of all provinces
   * @param successF function to call if successful
   * @param errorF function to call if a error happens
   */
  static readCityProvinceByZIP(zip, countryName, currentLanguage, allProvinces, successF, errorF) {
    this.getCityByZipCountry(zip, countryName, currentLanguage,
        (res) => {
          if (res.data.length > 0) {
            const addressDetails = res.data[0].address;
            const result = {
              city: null,
              province: null
            }

            // get the name of the city/town/village etc.
            result.city = res.data[0].display_name.split(',')[0];  // this usually gets zip
            if (addressDetails.city) {
              result.city = addressDetails.city;
            }
            else if (addressDetails.town) {
              result.city = addressDetails.town;
            }
            else if (addressDetails.village) {
              result.city = addressDetails.village;
            }
            else if (addressDetails.municipality) {
              result.city = addressDetails.municipality;
            }

            // set province according to addressDetails
            for (let j = 0; j < allProvinces.length; j++) {
              if (allProvinces[j].name === addressDetails.state || allProvinces[j].translatedName === addressDetails.state) {
                result.province = allProvinces[j].id;
                break;
              }
            }
            if (!result.province) {  // special case for Wien and Berlin which result in no addressDetails.state
              for (let j = 0; j < allProvinces.length; j++) {
                if (allProvinces[j].name === addressDetails.city || allProvinces[j].translatedName === addressDetails.city) {  // Wien / Berlin
                  result.province = allProvinces[j].id;
                  break;
                }
              }
            }

            successF(result);
          } else {
            errorF()
          }
        },
        () => {
          errorF()
        }
    )
  }

  /**
   * Converts parts of the address to coordinates
   *
   * @param street Streetnumber and streetname of address
   * @param zip Postalcode of address
   * @param city City of address
   * @param successF function to run when request is successfull
   * @param errorF function to run when request failed
   */
  static async convertAddressToCoordinates(street, zip, city, successF, errorF) {
    await WrapperService.get(ENDPOINT + '&street=' + street + '&postalcode=' + zip + '&city=' + city, null, serviceName, successF, errorF);
  }

  /**
   * Converts parts of the address to coordinates
   *
   * @param zip Postalcode of address
   * @param city City of address
   * @param successF function to run when request is successfull
   * @param errorF function to run when request failed
   */
  static async getCoordinatesByZipCity(zip, city, successF, errorF) {
    await WrapperService.get(ENDPOINT + '&postalcode=' + zip + '&city=' + city, null, serviceName, successF, errorF);
  }

  static async getCityByZipCountry(zip, country, currentLanguage, successF, errorF) {
    await WrapperService.get(ENDPOINT + '&accept-language=' + currentLanguage + '&addressdetails=1&postalcode=' + zip + '&country=' + country, null, serviceName, successF, errorF);
  }
}
